// extracted by css-extract-rspack-plugin
export default {"rating":"Rating-module__rating___qhQtp","empty":"Rating-module__empty___pL74h"};